export const MIN_CLERK_JS_VERSION = '6.0.0';

export const USER_PROFILE_NAVBAR_ROUTE_ID = {
  ACCOUNT: 'account',
  SECURITY: 'security',
  BILLING: 'billing',
  API_KEYS: 'apiKeys',
};

export const ORGANIZATION_PROFILE_NAVBAR_ROUTE_ID = {
  GENERAL: 'general',
  MEMBERS: 'members',
  BILLING: 'billing',
  API_KEYS: 'apiKeys',
  SECURITY: 'security',
};

export const USER_BUTTON_ITEM_ID = {
  MANAGE_ACCOUNT: 'manageAccount',
  SIGN_OUT: 'signOut',
};

export const USER_PROFILE_CARD_SCROLLBOX_ID = 'clerk-profileCardScrollBox';
export const ORGANIZATION_PROFILE_CARD_SCROLLBOX_ID = 'clerk-organizationProfileScrollBox';
